import { render, staticRenderFns } from "./IconPipelinePhaseApproach.vue?vue&type=template&id=12c333ba&"
import script from "./IconPipelinePhaseApproach.vue?vue&type=script&lang=ts&"
export * from "./IconPipelinePhaseApproach.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports